var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      attrs: { href: "/apps/" + _vm.app.application.id + "?from=game_listing" }
    },
    [
      _c("game-icon", {
        attrs: {
          images: _vm.app.application.images,
          ua: _vm.ua,
          appName: _vm.app.application.name
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "c-games_list_body" }, [
        _c("h3", { staticClass: "c-games_title" }, [
          _vm._v(_vm._s(_vm.app.application.name))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "c-games_genre" }, [
          _vm._v(_vm._s(_vm.app.application.messageBundles.shortDescription))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "c-games_typeWrap" }, [
          _vm.hasPCAppWin || _vm.hasPCAppMac
            ? _c("div", { staticClass: "c-games_type c-games_type-pcApp" }, [
                _vm.hasPCAppWin || _vm.hasPCAppMac
                  ? _c("ul", { staticClass: "c-label_os" }, [
                      _vm.hasPCAppWin
                        ? _c("li", { staticClass: "c-label_os_item" }, [
                            _vm._v("Win")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPCAppMac
                        ? _c("li", { staticClass: "c-label_os_item" }, [
                            _vm._v("Mac")
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._m(0)
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.hasWeb
            ? _c("div", { staticClass: "c-games_type" }, [_vm._m(1)])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm.ua === "pc"
        ? _c("div", { staticClass: "c-games_hoverBox" }, [
            _c(
              "p",
              {
                staticClass:
                  "c-games_hoverBox_button c-games_hoverBox_button-detail"
              },
              [_c("DetailIcon", { staticClass: "svg" })],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c-games_type_labelContainer" }, [
      _c("span", { staticClass: "c-label c-label-gameType" }, [
        _vm._v("PCアプリ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c-games_type_labelContainer" }, [
      _c("span", { staticClass: "c-label c-label-gameType" }, [
        _vm._v("PCブラウザ")
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-502e95f0", { render: render, staticRenderFns: staticRenderFns })
  }
}